import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegfiPhonePipe } from './legfi-phone.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [LegfiPhonePipe],
    exports: [LegfiPhonePipe],
})
export class LegfiPhonePipeModule
{
}
